import * as React from 'react';
import ArticleCollectionView from '@reverbdotcom/commons/dist/components/article_collection_view';
import { trackView, ARTICLE_TYPE } from '@reverbdotcom/commons/dist/tracker';

interface Props {
  articles: any[];
  heading: string;
  action?: JSX.Element;
}

class RelatedArticles extends React.Component<Props, {}> {
  componentDidMount() {
    this.trackImpression();
  }

  componentDidUpdate(prevProps) {
    if (this.props.articles === prevProps.articles) { return; }
    this.trackImpression();
  }

  trackImpression() {
    if (this.props.articles.length < 2) { return; }

    trackView({
      componentName: 'RelatedArticleCard',
      type: ARTICLE_TYPE,
      ids: this.props.articles.map((article) => article.id),
    });
  }

  render() {
    if (this.props.articles.length < 2) { return null; }

    return (
      <ArticleCollectionView
        title={this.props.heading}
        articles={this.props.articles}
        action={this.props.action}
      />
    );
  }
}

export default RelatedArticles;



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/src/components/shared/related_articles.tsx